<template>
  <v-dialog
    v-model="isShowModal"
    max-width="90%"
    scrollable
    persistent
    content-class="move-account-dialog">
    <v-card class="modal-flex-container">
      <material-card
        :title="$t('user.moveUser')"
        tile
        color="green"
        full-width
      >
        <div class="modal-fixed-header">
          <v-container>
            <v-form ref="form">
              <v-layout wrap>
                <v-flex
                  xs12
                  md12
                >
                  <span>{{ $t('customer.moveAccount.move') }} <b><span style="color: red">{{ numOfOwnedVoucher }}</span></b> {{ $t('customer.moveAccount.from') }} <b>{{fromUserFullname}} &lt;{{ fromUserEmail }}&gt;</b></span>
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    v-model="toNewEmail"
                    :rules="[ruleRequiredValue, ruleValidEmailFormat]"
                    :label="$t('customer.moveAccount.to')"
                    :name="$t('customer.moveAccount.to')"
                    prepend-icon="mdi-email"
                    type="text"
                    class="required"
                  />
                </v-flex>
                <v-flex
                  v-if="!isInvalidNewAccount()"
                  xs12
                  md12
                >
                  <span>{{ $t('customer.email')}} <b>{{toNewEmail}}</b> </span>
                  <span v-if="isExistingUser"> {{ $t('customer.moveAccount.isExisting') }}</span>
                  <span v-else> {{ $t('customer.moveAccount.isNew') }}</span>
                </v-flex>
                <v-flex
                  v-if="verificationCode && !isInvalidNewAccount()"
                  xs12
                  md12
                >
                  <span>{{ $t('customer.moveAccount.vefiricationCode') }} <b><span style="color: blue">{{ verificationCode }}</span></b></span>
                  <v-icon
                    class="ml-1"
                    size="16"
                    @click="opCopyClipboard(verificationCode)">mdi-content-copy</v-icon>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
          <v-progress-linear
            v-show="progressBar"
            :indeterminate="progressBar"
            color="success"
            height="5"
            value="30"
          />
        </div>
        <v-card-text class="modal-scrollable-body">
          <v-data-table
            :no-data-text="$t('common.noDataAvailable')"
            :headers="voucherHeaders"
            :items="voucherList"
            :loading="true"
            hide-actions
            class="sticky-header-table"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="text--darken-3 font-medium"
                v-text="$t(header.text)"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }">
              <td
                v-for="(header, index) in voucherHeaders"
                :key="header.value + index"
              >
                <div class="mx-1">
                  <!-- <div v-if="header.value == 'voucherSerial'">
                    <div
                      v-for="(voucherSerial, index) in item[header.value]"
                      :key="voucherSerial + index">
                      {{ voucherSerial }}
                    </div>
                    <div v-if="item[header.value].length >= 5">...</div>
                  </div> -->
                  <div v-if="header.value == 'customer'">
                    <span v-if="item.customerName">{{ item.customerName }}</span><br>
                    <span v-if="item.customerEmail">{{ item.customerEmail }}</span>
                  </div>
                  <div v-else-if="header.value == 'userAction'">
                    <span v-if="item.userName">{{ item.userName }}</span><br>
                    <span v-if="item.userEmail">{{ item.userEmail }}</span>
                  </div>
                  <div v-else>{{ item[header.value] }}</div>
                </div>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </material-card>
      <v-card-actions class="modal-fixed-footer">
        <v-btn
          :disabled="isInvalidNewAccount() || !verificationCode"
          color="warning darken-1"
          @click="onConfirmCreateAndTransfer()"
        >{{ $t('common.confirm') }}
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="getCreateUserAndMoveOwnedVoucher()"
        >
          <v-icon dark>mdi-refresh</v-icon><span>{{ $t("common.refresh") }}</span>
        </v-btn>
        <v-spacer />
        <v-btn
          color="error darken-1"
          @click="isShowModal = false"
        >{{ $t("common.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import ToastType from 'enum/toastType'
import functionUtils from 'utils/functionUtils'
import validationRules from 'utils/validationRules'
import { FOR_CONASI_TARGET } from 'utils/constants'

export default {
  components: {},
  data: () => ({
    voucherHeaders: [
      // { sortable: false, text: 'common.nonumber', value: 'stt', align: 'center' },
      { sortable: false, text: 'evoucher.quantity', value: 'count', align: 'center' },
      { sortable: false, text: 'evoucher.name', value: 'name', align: 'center' },
      { sortable: false, text: 'evoucher.workpieceCode', value: 'code', align: 'center' },
      { sortable: false, text: 'evoucher.issuedCode', value: 'issuance', align: 'center' },
      { sortable: false, text: FOR_CONASI_TARGET ? 'evoucher.issuance.price' : 'evoucher.issuance.pricePercent', value: 'price', align: 'center' }
    ],
    voucherList: [],
    fromUserFullname: null,
    fromUserEmail: null,
    verificationCode: null,
    numOfOwnedVoucher: 0,
    toNewEmail: null,
    isExistingUser: false,
    isShowModal: false,
    progressBar: false
  }),
  computed: {
    ...mapGetters([
    ])
  },
  watch: {
  },
  created () {
  },
  methods: {
    isInvalidNewAccount: function () {
      return !functionUtils.validateEmail(this.toNewEmail)
    },
    ruleRequiredValue (value) {
      return validationRules.ruleRequiredValue(value)
    },
    ruleValidEmailFormat (value) {
      return validationRules.ruleValidEmailFormat(value)
    },
    opCopyClipboard: function (text) {
      navigator.clipboard.writeText(text)
    },
    onShowModal: function (customerInfo) {
      // Reset the form validation state
      this.$refs.form.resetValidation()
      // this.userId = customerInfo.id
      this.fromUserFullname = customerInfo.fullname
      // this.gender = customerInfo.gender
      // this.phone = customerInfo.phone
      this.fromUserEmail = customerInfo.email
      this.toNewEmail = null
      this.isExistingUser = false
      this.voucherList = []
      this.isShowModal = true
      this.getCreateUserAndMoveOwnedVoucher()
    },
    onConfirmCreateAndTransfer: function () {
      if (functionUtils.validateEmail(this.toNewEmail)) {
        this.$message.prompt({
          message: this.$t('confirmActiveKey.toContinue'),
          inputTitle: this.$t('confirmActiveKey.verificationCodes'),
          prependIcon: 'mdi-account-key',
          onConfirm: (text) => {
            this.getCreateUserAndMoveOwnedVoucher(text)
          }
        });
      }
    },
    getCreateUserAndMoveOwnedVoucher: function (verifyCode = null) {
      let filter = {
        fromOldEmail: this.fromUserEmail,
        toNewEmail: this.toNewEmail,
        verifyCode: verifyCode
      }
      this.progressBar = true
      this.CREATE_USER_AND_MOVE_VOUCHER_OWNER(filter).then(
        function (res) {
          let data = res.data.vouchers
          this.voucherList = []
          for (let i = 0, size = data.length; i < size; i++) {
            let voucherObj = {
              stt: i + 1,
              id: data[i].id,
              count: data[i].count,
              name: data[i].name,
              issuance: data[i].prefix + ' - ' + data[i].suffix,
              code: data[i].code,
              price: data[i].value,
            }
            this.voucherList.push(voucherObj)
          }
          this.isExistingUser = !res.data.is_new_user
          this.numOfOwnedVoucher = res.data.num_of_vouchers_owned
          this.verificationCode = res.data.verify_code
          this.progressBar = false
        }.bind(this)
      ).catch(
        function (error) {
          this.progressBar = false
          this.ON_SHOW_TOAST({
            message: this.$t(`${error.response.data.message}`),
            styleType: ToastType.ERROR
          })
        }.bind(this)
      )
    },
    ...mapActions([
      'ON_SHOW_TOAST',
      'CREATE_USER_AND_MOVE_VOUCHER_OWNER'
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal {
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.v-card {
  margin-bottom: 0px !important;
  margin-top: 0px !important; /* Remove unexpected space on above dialog box */
  padding-top: 10px !important; /* Remove unexpected space on above dialog box */
}
:deep(table.v-table tbody td) {
  padding: 0 !important;
}
:deep(table.v-table thead th) {
  padding-left: 0 !important;
}
.modal-scrollable-body {
  /* MAX-HEIGHT: Dynamic calculation
     90vh (of the dialog) - approx 350px (header + footer) */
  max-height: calc(90vh - 350px);
}
</style>
